// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 735px) {
  .scroll-up .ant-layout-header.nkl-deck-header.sticky-header {
    right: 0;
    left: 0;
    top: 50px;
    transition: all 250ms ease-out;
  }
  .scroll-up .ant-layout-header.nkl-deck-header.sticky-header.nkl-deck-header-admin {
    top: 100px;
  }
  .scroll-down .ant-layout-header.nkl-deck-header.sticky-header {
    right: 0;
    left: 0;
    top: 0;
    transition: all 250ms ease-out;
  }
  .scroll-down .ant-layout-header.nkl-deck-header.sticky-header.nkl-deck-header-admin {
    top: 50px;
  }
}
.ant-layout-header.nkl-deck-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  padding: 0 1rem;
  line-height: 50px;
  z-index: 1003;
  background: #fff;
  color: #59606D;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #F5F7FA;
}
.ant-layout-header.nkl-deck-header.sticky-header {
  position: fixed;
  z-index: 1004;
  right: 64px;
  width: auto;
  left: unset;
  box-shadow: none;
  display: flex;
  opacity: 0;
  transition: all 250ms ease-out;
}
.ant-layout-header.nkl-deck-header.sticky-header .nkl-deck-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 735px) {
  .ant-layout-header.nkl-deck-header {
    height: 50px;
  }
  .ant-layout-header.nkl-deck-header.sticky-header {
    width: 100%;
    right: 0;
    left: 0;
    top: 50px;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #F5F7FA;
  }
  .ant-layout-header.nkl-deck-header.sticky-header.nkl-deck-header-admin {
    top: 100px;
  }
  .ant-layout-header.nkl-deck-header a {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    display: block;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.ant-layout-header.nkl-deck-header .ant-btn {
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.ant-layout-header.nkl-deck-header .nkl-deck-popover {
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  padding-top: 0;
}
.ant-layout-header.nkl-deck-header .rewards-deck-popover.ant-popover {
  width: 444px;
  padding-top: 0;
}
.ant-layout-header.nkl-deck-header.is-hidden {
  display: none;
}
.ant-layout-header.nkl-deck-header.is-loaded.sticky-header {
  opacity: 1;
  transition: all 250ms ease-out;
}
.ant-layout-header.nkl-deck-header.is-loaded .nkl-deck-delegate-text {
  opacity: 1;
  transform: translateY(0);
}
.ant-layout-header.nkl-deck-header.is-loaded .nkl-deck-avatar-btn.ant-btn {
  padding: 0;
  opacity: 1;
  transition: all 250ms ease-out;
}
.ant-layout-header.nkl-deck-header .deck-company-logo,
.ant-layout-header.nkl-deck-header .deck-logo-placeholder {
  float: left;
  height: 36px;
  margin: 7px 24px 7px 0;
  background: rgba(0, 0, 0, 0.3);
}
@media screen and (max-width: 735px) {
  .ant-layout-header.nkl-deck-header .deck-company-logo,
  .ant-layout-header.nkl-deck-header .deck-logo-placeholder {
    margin: 7px 0;
  }
}
.ant-layout-header.nkl-deck-header .menu-button {
  display: none;
  padding: 0;
}
@media screen and (max-width: 1407px) {
  .ant-layout-header.nkl-deck-header .menu-button {
    display: block;
    float: left;
    border: none;
    box-shadow: none;
    margin-top: 9px;
    margin-right: 16px;
  }
}
.ant-layout-header.nkl-deck-header .deck-user-menu.ant-menu:focus {
  box-shadow: none;
}
.ant-layout-header.nkl-deck-header .deck-user-menu .ant-menu-item-disabled .ant-menu-title-content {
  color: #b1baca;
}
.ant-layout-header.nkl-deck-header .deck-user-menu .ant-menu-title-content {
  color: black;
}
.ant-layout-header.nkl-deck-header .deck-company-logo {
  background: transparent;
}
.ant-layout-header.nkl-deck-header .deck-logo-placeholder {
  height: 36px;
  width: 36px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.25);
  animation: fadeInOut 1s infinite;
}
.ant-layout-header.nkl-deck-header .nkl-deck-delegate-text {
  color: #d93321;
  transition: all 250ms ease-out;
  transform: translateY(-100px);
  opacity: 0;
}
.ant-layout-header.nkl-deck-header.nkl-deck-user-info {
  transform: translateX(50%);
  transition: all 250ms ease-out;
}
.ant-layout-header.nkl-deck-header.nkl-deck-user-info button {
  vertical-align: middle;
  margin-right: 8px;
  display: flex;
}
.ant-layout-header.nkl-deck-header.nkl-deck-user-info .ant-btn-text:not(.nkl-deck-avatar-btn) {
  color: #59606D;
}
.ant-layout-header.nkl-deck-header.nkl-deck-user-info .ant-btn-text:hover,
.ant-layout-header.nkl-deck-header.nkl-deck-user-info .ant-btn-text:focus {
  background: #F5F7FA;
  border-color: transparent;
}
.ant-layout-header.nkl-deck-header.nkl-deck-user-info .ant-typography {
  vertical-align: text-top;
}
.ant-layout-header.nkl-deck-header.is-loaded.nkl-deck-user-info {
  opacity: 1;
  transform: translateX(0);
}
@media screen and (max-width: 735px) {
  .ant-layout-header.nkl-deck-header.is-loaded.nkl-deck-user-info {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
.ant-layout-header.nkl-deck-header.is-loaded .nkl-deck-delegate-text {
  opacity: 1;
  transform: translateY(0);
}
.ant-layout-header.nkl-deck-header .mobile-dot {
  display: none;
}
@media screen and (max-width: 400px) {
  .ant-layout-header.nkl-deck-header .mobile-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #DE1B1B;
    border-radius: 100%;
    position: absolute;
    left: 29px;
    top: 5px;
  }
}
.ant-layout-header.nkl-deck-header .nkl-deck-avatar-btn {
  padding: 0;
  height: 36px;
  width: 36px;
  border: none;
  float: right;
  top: 7px;
  opacity: 0;
  transition: all 250ms ease-out;
}
.ant-layout-header.nkl-deck-header .nkl-deck-avatar-btn:hover {
  color: inherit;
  background-color: inherit;
}
.ant-layout-header.nkl-deck-header .desktop-count {
  display: inline-block;
}
@media screen and (max-width: 400px) {
  .ant-layout-header.nkl-deck-header .desktop-count {
    display: none;
  }
}
@media screen and (max-width: 400px) {
  .ant-layout-header.nkl-deck-header .ant-badge {
    display: none;
  }
}
.ant-layout-header.nkl-deck-header .ant-badge-count {
  background: #DE1B1B;
  padding: 0px 8px;
  font-size: 14px;
  font-weight: 600;
}
@media screen and (max-width: 400px) {
  .ant-layout-header.nkl-deck-header #deckRewardsMobileBtn .ant-btn-icon,
  .ant-layout-header.nkl-deck-header #deckArcadeMobileBtn .ant-btn-icon,
  .ant-layout-header.nkl-deck-header #deckNotificationsPopoverBtn .ant-btn-icon {
    margin-inline-end: 0;
  }
}
.ant-layout-header.nkl-deck-header .nkl-deck-rewards-btn.ant-btn {
  border-radius: 10px;
  padding: 8px 10px;
  font-weight: 600;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 36px;
}
.ant-layout-header.nkl-deck-header .nkl-deck-rewards-btn.ant-btn > .points {
  margin-left: 0;
  margin-right: 0;
}
@media screen and (max-width: 400px) {
  .ant-layout-header.nkl-deck-header .nkl-deck-rewards-btn.ant-btn > .points {
    margin-left: 8px;
  }
}
.ant-layout-header.nkl-deck-header .notification-bell-icon {
  height: 20px;
}
.nkl-deck-app-root-admin .ant-layout-header.nkl-deck-header {
  top: 50px;
  transition: all 250ms ease-out;
}
.ant-popover.nkl-deck-popover .ant-popover-inner {
  max-height: 75vh;
  overflow: auto;
  padding: 24px;
}
.ant-popover.nkl-deck-popover.deck-notifications-options-menu-outer .ant-popover-inner {
  padding: 0;
}
.ant-popover.nkl-deck-popover.deck-notifications-options-menu-outer .ant-popover-inner button {
  width: 100%;
  display: flex;
  align-items: center;
}
.ant-popover.nkl-deck-popover.deck-notifications-options-menu-outer .ant-popover-inner li:hover {
  background-color: #F5F7FA;
}
.ant-popover.nkl-deck-popover .nkl-deck-popover {
  max-height: none;
  overflow: visible;
}
.ant-popover.nkl-deck-popover.nkl-deck-popover-menu-container .ant-popover-inner-content {
  padding: 0;
  width: auto;
}
.ant-popover.nkl-deck-popover.nkl-deck-popover-menu-container .ant-menu {
  padding: 0;
}
.ant-popover.nkl-deck-popover.nkl-deck-popover-menu-container .ant-menu .ant-menu-item {
  border-radius: 8px;
}
.ant-popover.nkl-deck-popover .ant-popover-inner {
  width: auto;
  height: auto;
  border-radius: 16px;
}
.ant-popover.nkl-deck-popover .nkl-deck-popover-menu {
  border-right: none;
}
.ant-popover.nkl-deck-popover .nkl-deck-popover-menu a:focus {
  text-decoration: underline;
}
.ant-popover.nkl-deck-popover .ant-menu {
  font-size: 16px;
}
.ant-popover.nkl-deck-popover .ant-menu-item-icon {
  min-width: 24px;
  font-size: 24px;
}
.ant-popover.nkl-deck-popover .ant-menu-item.menu-item {
  padding: 10px;
}
.ant-popover.nkl-deck-popover .ant-menu-item.menu-item .ant-menu-title-content {
  margin-left: 1px;
}
.ant-popover.nkl-deck-popover .ant-menu-item svg {
  margin-right: 12px;
  width: 24px;
  fill: currentColor;
  vertical-align: text-bottom;
}
.ant-popover.nkl-deck-popover .ant-layout-sider {
  background: #fff;
}
.ant-popover.nkl-deck-popover .ant-layout-sider-trigger {
  display: none;
}
.ant-popover.nkl-deck-popover .ant-layout-sider-has-trigger {
  padding-bottom: 0;
}
.ant-popover.nkl-deck-popover .ant-layout-sider-has-trigger .ant-menu-inline {
  border-right: none;
}
.nkl-deck-popover .profile-popover .ant-menu .menu-item:hover,
.user-drawer .profile-popover .ant-menu .menu-item:hover {
  background-color: #F5F7FA;
}
.arcade-popover .ant-divider {
  margin: 16px 0;
  border-top: 1px solid #C9D1DF;
}
.arcade-popover .arcade-menu .redeem-option {
  width: 252px;
  height: 52px;
}
@media screen and (max-width: 735px) {
  .arcade-popover .arcade-menu .redeem-option {
    width: 100%;
  }
}
#deckUserPopoverBtn .ant-avatar-string {
  transform: none !important;
  position: static;
  line-height: 36px;
}
#deckNotificationsPopoverBtn .ant-badge {
  margin-left: -16px;
  font-size: 14px;
  font-weight: 600;
}
#deck-rewardsPopoverContainer {
  display: inline-flex;
}
@media screen and (max-width: 735px) {
  #deck-rewardsPopoverContainer {
    display: none;
  }
}
#deck-rewardsMobileContainer {
  display: none;
}
@media screen and (max-width: 735px) {
  #deck-rewardsMobileContainer {
    display: inline-flex;
  }
}
#deck-arcadeMenuContainer {
  display: inline-flex;
}
@media screen and (max-width: 735px) {
  #deck-arcadeMenuContainer {
    display: none;
  }
}
#deck-arcadeMobileContainer {
  display: none;
}
@media screen and (max-width: 735px) {
  #deck-arcadeMobileContainer {
    display: inline-flex;
  }
}
#deck-notificationsMenuContainer {
  display: inline-flex;
}
#deck-notificationsMenuContainer .ant-popover-inner {
  padding-bottom: 0;
}
@media screen and (max-width: 735px) {
  #deck-notificationsMenuContainer {
    display: none;
  }
}
#deck-notificationsMobileContainer {
  display: none;
}
@media screen and (max-width: 735px) {
  #deck-notificationsMobileContainer {
    display: inline-flex;
  }
}
#deck-userMenuContainer {
  display: block;
}
@media screen and (max-width: 735px) {
  #deck-userMenuContainer {
    display: none;
  }
}
#deck-userMobileContainer {
  display: none;
}
@media screen and (max-width: 735px) {
  #deck-userMobileContainer {
    display: block;
  }
}
@media screen and (max-width: 735px) {
  .arcade-deck-drawer .rewards-header-mobile,
  .rewards-drawer .rewards-header-mobile,
  .notifications-deck-drawer .rewards-header-mobile,
  .user-drawer .rewards-header-mobile {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    display: flex;
    align-items: center;
  }
  .arcade-deck-drawer .rewards-header-mobile .gift-code-callout-header,
  .rewards-drawer .rewards-header-mobile .gift-code-callout-header,
  .notifications-deck-drawer .rewards-header-mobile .gift-code-callout-header,
  .user-drawer .rewards-header-mobile .gift-code-callout-header {
    color: #59606D;
    margin-left: 3px;
  }
  .arcade-deck-drawer .rewards-header,
  .rewards-drawer .rewards-header,
  .notifications-deck-drawer .rewards-header,
  .user-drawer .rewards-header {
    display: none;
  }
  .arcade-deck-drawer .rewards-header.display-mobile,
  .rewards-drawer .rewards-header.display-mobile,
  .notifications-deck-drawer .rewards-header.display-mobile,
  .user-drawer .rewards-header.display-mobile {
    display: flex;
    align-items: center;
  }
  .arcade-deck-drawer .notifications-popover-container,
  .rewards-drawer .notifications-popover-container,
  .notifications-deck-drawer .notifications-popover-container,
  .user-drawer .notifications-popover-container {
    width: auto;
  }
}
.user-drawer .ant-drawer-body {
  padding-top: 0;
}
.user-drawer .ant-drawer-body .menu-item {
  padding: 10px;
  border: none;
  width: 100% !important;
}
.rewards-deck-popover .ant-btn,
.arcade-deck-drawer .ant-btn,
.notifications-deck-drawer .ant-btn,
.user-drawer .ant-btn {
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.rewards-deck-popover.ant-drawer-content .ant-drawer-header,
.arcade-deck-drawer.ant-drawer-content .ant-drawer-header,
.notifications-deck-drawer.ant-drawer-content .ant-drawer-header,
.user-drawer.ant-drawer-content .ant-drawer-header {
  border-bottom: none;
  padding-top: 18px;
  padding-right: 18px;
}
.rewards-deck-popover.ant-drawer-content .ant-drawer-header button,
.arcade-deck-drawer.ant-drawer-content .ant-drawer-header button,
.notifications-deck-drawer.ant-drawer-content .ant-drawer-header button,
.user-drawer.ant-drawer-content .ant-drawer-header button {
  margin-right: 0;
}
.rewards-deck-popover.ant-drawer-content .ant-drawer-header .ant-drawer-header-title,
.arcade-deck-drawer.ant-drawer-content .ant-drawer-header .ant-drawer-header-title,
.notifications-deck-drawer.ant-drawer-content .ant-drawer-header .ant-drawer-header-title,
.user-drawer.ant-drawer-content .ant-drawer-header .ant-drawer-header-title {
  display: flex;
  justify-content: flex-end;
  flex-direction: row-reverse;
  align-items: baseline;
  padding-top: 6px;
}
.nkl-deck-icon {
  fill: currentColor;
}
.nkl-deck-icon.reward-icon {
  width: 19.67px;
  height: 19.67px;
  vertical-align: initial;
}
.nkl-deck-icon path {
  fill: currentColor;
}
.deck-menu-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: bottom;
}
.deck-menu-icon svg {
  width: 100%;
  fill: currentColor;
}
.deck-menu-label-with-icon {
  margin-left: 12px;
  vertical-align: bottom;
  color: #444A53;
}
@keyframes fadeInOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.ant-select-dropdown.budget-dropdown {
  z-index: 100000;
}
.ots-input-button .ant-input-affix-wrapper input.ant-input {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/deck/deck/deck.less"],"names":[],"mappings":"AAIA;EAGY;IACI,QAAA;IACA,OAAA;IACA,SAAA;IACA,8BAAA;EALd;EAOc;IACI,UAAA;EALlB;EAaU;IACI,QAAA;IACA,OAAA;IACA,MAAA;IACA,8BAAA;EAXd;EAac;IACI,SAAA;EAXlB;AACF;AAiBA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,uEAAA;AAfJ;AAiBI;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;AAfR;AAMI;EAYQ,aAAA;EACA,uBAAA;EACA,mBAAA;AAfZ;AAmBI;EAAA;IACI,YAAA;EAhBN;EAkBM;IACI,WAAA;IACA,QAAA;IACA,OAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;IACA,uEAAA;EAhBV;EAkBU;IACI,UAAA;EAhBd;EAGE;IAkBQ,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,cAAA;IACA,uBAAA;IAAA,kBAAA;EAlBV;AACF;AApCA;EA0DQ,mKAAA;AAnBR;AAvCA;EA8DQ,mKAAA;EACA,cAAA;AApBR;AAwBQ;EACI,YAAA;EACA,cAAA;AAtBZ;AA0BI;EACI,aAAA;AAxBR;AA4BQ;EACI,UAAA;EACA,8BAAA;AA1BZ;AAuBI;EAOQ,UAAA;EACA,wBAAA;AA3BZ;AA+BY;EACI,UAAA;EACA,UAAA;EACA,8BAAA;AA7BhB;AA/DA;;EAmGQ,WAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AAhCR;AAkCQ;EAAA;;IACI,aAAA;EA9BV;AACF;AA5EA;EA8GQ,aAAA;EACA,UAAA;AA/BR;AAiCQ;EAAA;IACI,cAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EA9BV;AACF;AAmCY;EACI,gBAAA;AAjChB;AA7FA;EAoIgB,cAAA;AApChB;AAhGA;EAyIY,YAAA;AAtCZ;AAnGA;EA8IQ,uBAAA;AAxCR;AAtGA;EAkJQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;AAzCR;AA7GA;EA0JQ,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,UAAA;AA1CR;AA6CI;EACI,0BAAA;EACA,8BAAA;AA3CR;AAyCI;EAKQ,sBAAA;EACA,iBAAA;EAEA,aAAA;AA5CZ;AAoCI;EAaQ,cAAA;AA9CZ;AAiCI;;EAkBQ,mBAAA;EACA,yBAAA;AA/CZ;AA4BI;EAuBQ,wBAAA;AAhDZ;AAqDQ;EACI,UAAA;EACA,wBAAA;AAnDZ;AAqDY;EAAA;IACI,aAAA;IACA,WAAA;IACA,uBAAA;EAlDd;AACF;AAyCI;EAcQ,UAAA;EACA,wBAAA;AApDZ;AAtJA;EA+MQ,aAAA;AAtDR;AAwDQ;EAAA;IACI,qBAAA;IACA,UAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;EArDV;AACF;AArKA;EA8NQ,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;AAtDR;AAwDQ;EACI,cAAA;EACA,yBAAA;AAtDZ;AAnLA;EA8OQ,qBAAA;AAxDR;AA0DQ;EAAA;IACI,aAAA;EAvDV;AACF;AA2DQ;EAAA;IACI,aAAA;EAxDV;AACF;AAhMA;EA4PQ,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAzDR;AA+DQ;EAAA;;;IAEQ,oBAAA;EA3Dd;AACF;AAgEQ;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA9DZ;AAsDQ;EAWQ,cAAA;EACA,eAAA;AA9DhB;AAgEgB;EAAA;IACI,gBAAA;EA7DlB;AACF;AAhOA;EAmSQ,YAAA;AAhER;AAoEA;EAEQ,SAAA;EACA,8BAAA;AAnER;AAwEA;EAEQ,gBAAA;EACA,cAAA;EACA,aAAA;AAvER;AA0EI;EAEQ,UAAA;AAzEZ;AAuEI;EAKY,WAAA;EACA,aAAA;EACA,mBAAA;AAzEhB;AA6EgB;EACI,yBAAA;AA3EpB;AAwDA;EA0BQ,gBAAA;EACA,iBAAA;AA/ER;AAkFI;EAEQ,UAAA;EACA,WAAA;AAjFZ;AA8EI;EAOQ,UAAA;AAlFZ;AA2EI;EAUY,kBAAA;AAlFhB;AA0CA;EA8CQ,WAAA;EACA,YAAA;EACA,mBAAA;AArFR;AAqCA;EAoDQ,kBAAA;AAtFR;AAkCA;EAuDY,0BAAA;AAtFZ;AA+BA;EA4DQ,eAAA;AAxFR;AA4BA;EAgEQ,eAAA;EACA,eAAA;AAzFR;AA6FQ;EACI,aAAA;AA3FZ;AA0FQ;EAIQ,gBAAA;AA3FhB;AAkBA;EA8EY,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;AA7FZ;AAYA;EAsFQ,gBAAA;AA/FR;AASA;EA2FQ,aAAA;AAjGR;AAMA;EA+FQ,iBAAA;AAlGR;AAGA;EAkGY,kBAAA;AAlGZ;AAuGA;;EAKgB,yBAAA;AAxGhB;AA8GA;EAEQ,cAAA;EACA,6BAAA;AA7GR;AA0GA;EAQY,YAAA;EACA,YAAA;AA/GZ;AAiHY;EAAA;IACI,WAAA;EA9Gd;AACF;AAmHA;EAEQ,0BAAA;EACA,gBAAA;EACA,iBAAA;AAlHR;AAsHA;EAEQ,kBAAA;EACA,eAAA;EACA,gBAAA;AArHR;AAyHA;EACI,oBAAA;AAvHJ;AAyHI;EAAA;IACI,aAAA;EAtHN;AACF;AAyHA;EACI,aAAA;AAvHJ;AAyHI;EAAA;IACI,oBAAA;EAtHN;AACF;AAyHA;EACI,oBAAA;AAvHJ;AAyHI;EAAA;IACI,aAAA;EAtHN;AACF;AAyHA;EACI,aAAA;AAvHJ;AAyHI;EAAA;IACI,oBAAA;EAtHN;AACF;AAyHA;EACI,oBAAA;AAvHJ;AAsHA;EAIQ,iBAAA;AAvHR;AA0HI;EAAA;IACI,aAAA;EAvHN;AACF;AA0HA;EACI,aAAA;AAxHJ;AA0HI;EAAA;IACI,oBAAA;EAvHN;AACF;AA0HA;EACI,cAAA;AAxHJ;AA0HI;EAAA;IACI,aAAA;EAvHN;AACF;AA0HA;EACI,aAAA;AAxHJ;AA0HI;EAAA;IACI,cAAA;EAvHN;AACF;AA8HI;EAAA;;;;IAEQ,mBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,mBAAA;EAzHV;EAkHE;;;;IAUY,cAAA;IACA,gBAAA;EAtHd;EA2GE;;;;IAgBQ,aAAA;EArHV;EAuHU;;;;IACI,aAAA;IACA,mBAAA;EAlHd;EA8FE;;;;IAyBQ,WAAA;EAjHV;AACF;AAqHA;EAEQ,cAAA;AApHR;AAkHA;EAKY,aAAA;EACA,YAAA;EACA,sBAAA;AApHZ;AAyHA;;;;EAKQ,mKAAA;AAxHR;AA2HI;;;;EAEQ,mBAAA;EACA,iBAAA;EACA,mBAAA;AAvHZ;AAmHI;;;;EAOY,eAAA;AApHhB;AA6GI;;;;EAWY,aAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;AAlHhB;AAwHA;EACI,kBAAA;AAtHJ;AAwHI;EACI,cAAA;EACA,eAAA;EACA,uBAAA;AAtHR;AAgHA;EAUQ,kBAAA;AAvHR;AA2HA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAzHJ;AAqHA;EAOQ,WAAA;EACA,kBAAA;AAzHR;AA6HA;EACI,iBAAA;EACA,sBAAA;EACA,cAAA;AA3HJ;AA8HA;EACI;IACI,UAAA;EA5HN;EA+HE;IACI,YAAA;EA7HN;EAgIE;IACI,UAAA;EA9HN;AACF;AAoII;EACI,eAAA;AAlIR;AAyIY;EACI,UAAA;AAvIhB","sourcesContent":["@import '@nackle/origami/dist/less/color-vars.less';\n// *:focus {\n//     outline: 3px solid orange !important;\n// }\n@media screen and (max-width: 735px) {\n    .scroll-up {\n        .ant-layout-header.nkl-deck-header {\n            &.sticky-header {\n                right: 0;\n                left: 0;\n                top: 50px;\n                transition: all 250ms ease-out;\n\n                &.nkl-deck-header-admin {\n                    top: 100px;\n                }\n            }\n        }\n    }\n\n    .scroll-down {\n        .ant-layout-header.nkl-deck-header {\n            &.sticky-header {\n                right: 0;\n                left: 0;\n                top: 0;\n                transition: all 250ms ease-out;\n\n                &.nkl-deck-header-admin {\n                    top: 50px;\n                }\n            }\n        }\n    }\n}\n\n.ant-layout-header.nkl-deck-header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    height: 50px;\n    padding: 0 1rem;\n    line-height: 50px;\n    z-index: 1003;\n    background: #fff;\n    color: #59606D;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #F5F7FA;\n\n    &.sticky-header {\n        position: fixed;\n        z-index: 1004;\n        right: 64px;\n        width: auto;\n        left: unset;\n        box-shadow: none;\n        display: flex;\n        opacity: 0;\n        transition: all 250ms ease-out;\n\n        .nkl-deck-button-container {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n    }\n\n    @media screen and (max-width: 735px) {\n        height: 50px;\n\n        &.sticky-header {\n            width: 100%;\n            right: 0;\n            left: 0;\n            top: 50px;\n            justify-content: center;\n            align-items: center;\n            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #F5F7FA;\n\n            &.nkl-deck-header-admin {\n                top: 100px;\n            }\n        }\n\n        a {\n            margin-left: auto;\n            margin-right: auto;\n            position: relative;\n            display: block;\n            width: fit-content;\n        }\n    }\n\n    .ant-btn {\n        font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    }\n\n    .nkl-deck-popover {\n        font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n        padding-top: 0;\n    }\n\n    .rewards-deck-popover {\n        &.ant-popover {\n            width: 444px;\n            padding-top: 0;\n        }\n    }\n\n    &.is-hidden {\n        display: none;\n    }\n\n    &.is-loaded {\n        &.sticky-header {\n            opacity: 1;\n            transition: all 250ms ease-out;\n        }\n\n        .nkl-deck-delegate-text {\n            opacity: 1;\n            transform: translateY(0);\n        }\n\n        .nkl-deck-avatar-btn {\n            &.ant-btn {\n                padding: 0;\n                opacity: 1;\n                transition: all 250ms ease-out;\n            }\n        }\n    }\n\n    .deck-company-logo,\n    .deck-logo-placeholder {\n        float: left;\n        height: 36px;\n        margin: 7px 24px 7px 0;\n        background: rgba(0, 0, 0, 0.3);\n\n        @media screen and (max-width: 735px) {\n            margin: 7px 0;\n        }\n    }\n\n    .menu-button {\n        display: none;\n        padding: 0;\n\n        @media screen and (max-width: 1407px) {\n            display: block;\n            float: left;\n            border: none;\n            box-shadow: none;\n            margin-top: 9px;\n            margin-right: 16px;\n        }\n    }\n\n    .deck-user-menu {\n        &.ant-menu {\n            &:focus {\n                box-shadow: none;\n            }\n        }\n\n        .ant-menu-item-disabled {\n            .ant-menu-title-content {\n                color: @gray-50;\n            }\n        }\n\n        .ant-menu-title-content {\n            color: black;\n        }\n    }\n\n    .deck-company-logo {\n        background: transparent;\n    }\n\n    .deck-logo-placeholder {\n        height: 36px;\n        width: 36px;\n        border-radius: 24px;\n        background: rgba(0, 0, 0, 0.25);\n        animation: fadeInOut 1s infinite;\n    }\n\n    .nkl-deck-delegate-text {\n        color: #d93321;\n        transition: all 250ms ease-out;\n        transform: translateY(-100px);\n        opacity: 0;\n    }\n\n    &.nkl-deck-user-info {\n        transform: translateX(50%);\n        transition: all 250ms ease-out;\n\n        button {\n            vertical-align: middle;\n            margin-right: 8px;\n            // border-radius: 50%;\n            display: flex;\n        }\n\n        .ant-btn-text:not(.nkl-deck-avatar-btn) {\n            // padding: 4px 12px;\n            color: #59606D;\n        }\n\n        .ant-btn-text:hover,\n        .ant-btn-text:focus {\n            background: #F5F7FA;\n            border-color: transparent;\n        }\n\n        .ant-typography {\n            vertical-align: text-top;\n        }\n    }\n\n    &.is-loaded {\n        &.nkl-deck-user-info {\n            opacity: 1;\n            transform: translateX(0);\n\n            @media screen and (max-width: 735px) {\n                display: flex;\n                width: 100%;\n                justify-content: center;\n            }\n\n        }\n\n        .nkl-deck-delegate-text {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .mobile-dot {\n        display: none;\n\n        @media screen and (max-width: 400px) {\n            display: inline-block;\n            width: 6px;\n            height: 6px;\n            background: #DE1B1B;\n            border-radius: 100%;\n            position: absolute;\n            left: 29px;\n            top: 5px;\n        }\n    }\n\n    .nkl-deck-avatar-btn {\n        padding: 0;\n        height: 36px;\n        width: 36px;\n        border: none;\n        float: right;\n        top: 7px;\n        opacity: 0;\n        transition: all 250ms ease-out;\n\n        &:hover {\n            color: inherit;\n            background-color: inherit;\n        }\n    }\n\n    .desktop-count {\n        display: inline-block;\n\n        @media screen and (max-width: 400px) {\n            display: none;\n        }\n    }\n\n    .ant-badge {\n        @media screen and (max-width:400px) {\n            display: none;\n        }\n    }\n\n    .ant-badge-count {\n        background: #DE1B1B;\n        padding: 0px 8px;\n        font-size: 14px;\n        font-weight: 600;\n    }\n\n    #deckRewardsMobileBtn,\n    #deckArcadeMobileBtn,\n    #deckNotificationsPopoverBtn {\n        @media screen and (max-width: 400px) {\n            .ant-btn-icon {\n                margin-inline-end: 0;\n            }\n        }\n    }\n\n    .nkl-deck-rewards-btn {\n        &.ant-btn {\n            border-radius: 10px;\n            padding: 8px 10px;\n            font-weight: 600;\n            display: inline-flex;\n            flex-direction: row;\n            justify-content: center;\n            align-items: center;\n            height: 36px;\n\n            >.points {\n                margin-left: 0;\n                margin-right: 0;\n\n                @media screen and (max-width: 400px) {\n                    margin-left: 8px;\n                }\n            }\n        }\n    }\n\n    .notification-bell-icon {\n        height: 20px;\n    }\n}\n\n.nkl-deck-app-root-admin {\n    .ant-layout-header.nkl-deck-header {\n        top: 50px;\n        transition: all 250ms ease-out;\n    }\n}\n\n\n.ant-popover.nkl-deck-popover {\n    .ant-popover-inner {\n        max-height: 75vh;\n        overflow: auto;\n        padding: 24px;\n    }\n\n    &.deck-notifications-options-menu-outer {\n        .ant-popover-inner {\n            padding: 0;\n\n            button {\n                width: 100%;\n                display: flex;\n                align-items: center;\n            }\n\n            li {\n                &:hover {\n                    background-color: #F5F7FA;\n                }\n            }\n        }\n    }\n\n    .nkl-deck-popover {\n        max-height: none;\n        overflow: visible;\n    }\n\n    &.nkl-deck-popover-menu-container {\n        .ant-popover-inner-content {\n            padding: 0;\n            width: auto;\n        }\n\n        .ant-menu {\n            padding: 0;\n\n            .ant-menu-item {\n                border-radius: 8px;\n            }\n        }\n    }\n\n    .ant-popover-inner {\n        width: auto;\n        height: auto;\n        border-radius: 16px;\n    }\n\n    .nkl-deck-popover-menu {\n        border-right: none;\n\n        a:focus {\n            text-decoration: underline;\n        }\n    }\n\n    .ant-menu {\n        font-size: 16px;\n    }\n\n    .ant-menu-item-icon {\n        min-width: 24px;\n        font-size: 24px;\n    }\n\n    .ant-menu-item {\n        &.menu-item {\n            padding: 10px;\n\n            .ant-menu-title-content {\n                margin-left: 1px;\n            }\n        }\n\n        svg {\n            margin-right: 12px;\n            width: 24px;\n            fill: currentColor;\n            vertical-align: text-bottom;\n        }\n    }\n\n    .ant-layout-sider {\n        background: #fff;\n    }\n\n    // NackleMenu: override these next two because NackleMenu is inside a Sider\n    .ant-layout-sider-trigger {\n        display: none;\n    }\n\n    .ant-layout-sider-has-trigger {\n        padding-bottom: 0;\n\n        .ant-menu-inline {\n            border-right: none;\n        }\n    }\n}\n\n.nkl-deck-popover,\n.user-drawer {\n    .profile-popover {\n        .ant-menu {\n            .menu-item:hover {\n                background-color: #F5F7FA;\n            }\n        }\n    }\n}\n\n.arcade-popover {\n    .ant-divider {\n        margin: 16px 0;\n        border-top: 1px solid #C9D1DF;\n    }\n\n    .arcade-menu {\n        .redeem-option {\n            width: 252px;\n            height: 52px;\n\n            @media screen and (max-width: 735px) {\n                width: 100%;\n            }\n        }\n    }\n}\n\n#deckUserPopoverBtn {\n    .ant-avatar-string {\n        transform: none !important;\n        position: static;\n        line-height: 36px;\n    }\n}\n\n#deckNotificationsPopoverBtn {\n    .ant-badge {\n        margin-left: -16px;\n        font-size: 14px;\n        font-weight: 600;\n    }\n}\n\n#deck-rewardsPopoverContainer {\n    display: inline-flex;\n\n    @media screen and (max-width: 735px) {\n        display: none;\n    }\n}\n\n#deck-rewardsMobileContainer {\n    display: none;\n\n    @media screen and (max-width: 735px) {\n        display: inline-flex;\n    }\n}\n\n#deck-arcadeMenuContainer {\n    display: inline-flex;\n\n    @media screen and (max-width: 735px) {\n        display: none;\n    }\n}\n\n#deck-arcadeMobileContainer {\n    display: none;\n\n    @media screen and (max-width: 735px) {\n        display: inline-flex;\n    }\n}\n\n#deck-notificationsMenuContainer {\n    display: inline-flex;\n\n    .ant-popover-inner {\n        padding-bottom: 0;\n    }\n\n    @media screen and (max-width: 735px) {\n        display: none;\n    }\n}\n\n#deck-notificationsMobileContainer {\n    display: none;\n\n    @media screen and (max-width: 735px) {\n        display: inline-flex;\n    }\n}\n\n#deck-userMenuContainer {\n    display: block;\n\n    @media screen and (max-width: 735px) {\n        display: none;\n    }\n}\n\n#deck-userMobileContainer {\n    display: none;\n\n    @media screen and (max-width: 735px) {\n        display: block;\n    }\n}\n\n.arcade-deck-drawer,\n.rewards-drawer,\n.notifications-deck-drawer,\n.user-drawer {\n    @media screen and (max-width: 735px) {\n        .rewards-header-mobile {\n            margin-bottom: 12px;\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 16px;\n            display: flex;\n            align-items: center;\n\n            .gift-code-callout-header {\n                color: #59606D;\n                margin-left: 3px;\n            }\n        }\n\n        .rewards-header {\n            display: none;\n\n            &.display-mobile {\n                display: flex;\n                align-items: center;\n            }\n        }\n\n        .notifications-popover-container {\n            width: auto;\n        }\n    }\n}\n\n.user-drawer {\n    .ant-drawer-body {\n        padding-top: 0;\n\n        .menu-item {\n            padding: 10px;\n            border: none;\n            width: 100% !important;\n        }\n    }\n}\n\n.rewards-deck-popover,\n.arcade-deck-drawer,\n.notifications-deck-drawer,\n.user-drawer {\n    .ant-btn {\n        font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    }\n\n    &.ant-drawer-content {\n        .ant-drawer-header {\n            border-bottom: none;\n            padding-top: 18px;\n            padding-right: 18px;\n\n            button {\n                margin-right: 0;\n            }\n\n            .ant-drawer-header-title {\n                display: flex;\n                justify-content: flex-end;\n                flex-direction: row-reverse;\n                align-items: baseline;\n                padding-top: 6px;\n            }\n        }\n    }\n}\n\n.nkl-deck-icon {\n    fill: currentColor;\n\n    &.reward-icon {\n        width: 19.67px;\n        height: 19.67px;\n        vertical-align: initial;\n    }\n\n    path {\n        fill: currentColor;\n    }\n}\n\n.deck-menu-icon {\n    display: inline-block;\n    width: 24px;\n    height: 24px;\n    vertical-align: bottom;\n\n    svg {\n        width: 100%;\n        fill: currentColor;\n    }\n}\n\n.deck-menu-label-with-icon {\n    margin-left: 12px;\n    vertical-align: bottom;\n    color: #444A53;\n}\n\n@keyframes fadeInOut {\n    0% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.4;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n\n//remove this when v1 is removed\n.ant-select-dropdown {\n    &.budget-dropdown {\n        z-index: 100000;\n    }\n}\n\n.ots-input-button {\n    .ant-input-affix-wrapper {\n        input {\n            &.ant-input {\n                padding: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
